import { handleResponseError } from 'helpers/utils'
import { API } from './endpoint'
import httpClient from '../axios/interceptors'
import { AxiosResponse } from 'axios'
import {
  CreateFactoryContactActivityInput,
  DeleteFactoryContactActivityResponse,
  FactoryContactActivityListResponse,
  FactoryContactActivityResponse,
  FilterFactoryContactActivityInput,
  UpdateFactoryContactActivityInput,
} from './interface/factoryContactActivity.interface'

export const createFactoryContactActivity = async (
  input: CreateFactoryContactActivityInput
): Promise<FactoryContactActivityResponse> => {
  const data: AxiosResponse<FactoryContactActivityResponse> = await httpClient
    .post(API.factoryContactActivityCreate, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const loadFactoryContactActivities = async (
  filter: FilterFactoryContactActivityInput
): Promise<FactoryContactActivityListResponse> => {
  const data: AxiosResponse<FactoryContactActivityListResponse> = await httpClient
    .post(API.factoryContactActivityLoadAll, filter)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getFactoryContactActivity = async (
  id: string
): Promise<FactoryContactActivityResponse> => {
  const data: AxiosResponse<FactoryContactActivityResponse> = await httpClient
    .get(API.factoryContactActivityLoad(id))
    .catch((error) => handleResponseError(error))
  return data.data
}

export const updateFactoryContactActivity = async (
  input: UpdateFactoryContactActivityInput
): Promise<FactoryContactActivityResponse> => {
  const data: AxiosResponse<FactoryContactActivityResponse> = await httpClient
    .post(API.factoryContactActivityUpdate, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const deleteFactoryContactActivity = async (
  id: string
): Promise<DeleteFactoryContactActivityResponse> => {
  const data: AxiosResponse<DeleteFactoryContactActivityResponse> = await httpClient
    .post(API.factoryContactActivityDelete, { id })
    .catch((error) => handleResponseError(error))
  return data.data
}
